<template>
    <v-dialog
        v-model="isOpen"
        persistent
        max-width="600px"
    >
    <!-- Chat room Register Button -->
        <div class="chatroom">
            <div class="form-header">
                <h2>{{ $t('screener.chatroom.user.profile.update.title') }}</h2>
                <button class="close-btn" @click="$emit('handleprofileUpdate')" >&times;</button>
            </div>
            <form @submit.prevent="updateProfile">
                <!-- User Register Form -->
                <div class="profile-picture">
                    <img :src="croppedImagePreviewUrl" class="preview-image">
                    <label for="imageUpload" class="file-label">&#9998;</label>
                    <input type="file" id="imageUpload" accept="image/*" @change="previewImage">
                    <ImageCropper :dialog="showImageCropper" :imgSrc="imagePreviewUrl" @handleCroppedImage="handleCroppedImage"/>
                </div>
                <!-- <div class="profile-error">
                    <div class="field-error" v-if="errors.imageRaw">{{ errors.imageRaw }}</div>
                </div> -->
                <div class="input-group">
                    <label for="fullName">{{ $t('screener.chatroom.register.form.file.fullname.label') }}</label>
                    <input type="text" 
                    :class="{ 'error-field': errors.name }" 
                    id="fullName" 
                    v-model="member.name"
                    :placeholder="$t('screener.chatroom.register.form.file.fullname.label')"
                    @blur="validateFields('name')">
                    <div class="field-error" v-if="errors.name">{{ errors.name }}</div>
                </div>
                <div class="input-group">
                    <label for="bio">{{ $t('screener.chatroom.register.form.file.bio.label') }}</label>
                    <textarea id="bio" 
                    v-model="member.bio"
                    :class="{ 'error-field': errors.bio }" 
                    :placeholder="$t('screener.chatroom.register.form.file.bio.label')" 
                    rows="3"
                
                    @blur="validateFields('bio')"></textarea>
                    <div class="field-error" v-if="errors.bio">{{ errors.bio }}</div>
                </div>
                <button type="submit" class="submit-btn" :class="(isLoading) ? 'submit-btn-loading' : null">
                    <template v-if="isLoading">
                        {{ $t('screener.chatroom.user.profile.updating.btn.label') }}
                    </template>
                    <template v-else>
                        {{ $t('screener.chatroom.user.profile.update.title') }}
                    </template>
                </button>
            </form>
            <AlertMessage :dialog="alertDialog"/>
            <!-- User Register Form -->
        </div>
    </v-dialog>
</template>

<script>
import AlertMessage from "../../dialogBox/AlertMessage.vue";
import profilePlaceholder from '@/assets/placeholder.jpg';
import ImageCropper from '@/components/chatRoom/ImageCropper.vue' 
import ChatRoomService from "@/services/ChatRoomService";

export default {
    name : 'SenderProfileUpdate',
    props:{
        isOpen:{
            type:Boolean,
            default:false
        },
        chatRoomID: {
            type: String,
            require:true
        },
        senderProfile:{
            type:Object,
            default:null
        }
    },
    components:{
        AlertMessage,
        ImageCropper
    },
    computed: {
        croppedImagePreviewUrl: {
            get() {
                return this.member.profile_image || profilePlaceholder;
            },
            set(value) {
                this.member.profile_image = value;
            }
        }
    },
    watch:{
        senderProfile(newVal, oldVal){
            if(newVal){
                this.member = {...newVal}
            }
        }
    },
    data(){
        return {
            profilePlaceholder,
            isLoading:false,
            imagePreviewUrl: null,
            member:{},
            rules: {
                name: [
                    v => !!v || 'Full Name is required',
                    v => v && v.length >= 5 || 'Full Name must be greater than 5 characters',
                    v => v && v.length <= 30 || 'Full Name must be less than 30 characters',
                ],
                bio: [
                    v => !!v || 'Bio is required',
                    v => v && v.length <= this.DEFINES.CHATROOM_MEMBERS.validation.bio || `Bio must not exceed ${this.DEFINES.CHATROOM_MEMBERS.validation.bio} characters`,
                    v => v && v.length >= 10 || 'Bio must be at least 10 characters'
                ],
                imageRaw: [
                    value => !!value || 'Profile Image is required',
                    value => !value || value.size < 2000000 || 'Profile image size should be less than 2 MB!',
                ]
            },
            errors: {
                name: '',
                bio: '',
                profile_image: '',
            },
            alertDialog: {
                show: false,
                text: "",
                color: ""
            },
            showImageCropper:false,
            userUpdatedImage:null
        }
    },
    methods:{
        validateFields(field) {
            const value = this.member[field];
            const fieldRules = this.rules[field];

            // Check if fieldRules exists and is iterable
            if (!fieldRules || !Array.isArray(fieldRules)) {
                this.errors[field] = ''; // Clear any previous error if no rules exist
                return true; // Consider valid if no rules are defined
            }

            for (const rule of fieldRules) {
                const error = rule(value);
                if (error !== true) {
                this.errors[field] = error;
                return false; // Exit if validation fails
                }
            }

            this.errors[field] = ''; // Clear error if all rules pass
            return true; // Return success
        },
        validateForm() {
            let isValid = true;

            Object.keys(this.member).forEach(field => {
                
                if (!['imageRaw','profile_image'].includes(field)) {
                
                    if (!this.validateFields(field)) {
                        isValid = false; // Mark as invalid if any field fails
                    }
                }
            });

            return isValid; // Return the overall form validity
        },
        previewImage(event) {
            const file = event.target.files[0]
            this.member.imageRaw = file
            if (file) {
                // Create a URL for the image
                this.imagePreviewUrl = URL.createObjectURL(file)

                // Optional: Clean up the URL when component is destroyed
                this.$once('hook:beforeDestroy', () => {
                    URL.revokeObjectURL(this.imagePreviewUrl)
                })
            }

            const reader = new FileReader()
            
            reader.onloadend = () => {
                this.member.profile_image = reader.result
            }
            
            reader.readAsDataURL(file)
            this.showImageCropper = true
        },
        async updateProfile() {
            try {
                let self = this
                if(!this.validateForm()){
                    return;
                }
                this.isLoading = true
                this.removeKey(['acceptedProfiles','rejectedProfiles', 'profile_image'])
                
                var response = await this.$store.dispatch("chatroom/updateMember", this.member);
                
                // If user picked a new image then update the new Image in firebase
                if (this.userUpdatedImage) {
                    await ChatRoomService.__setMemberProfileImage(this.chatRoomID, this.member.id, this.userUpdatedImage)
                }

                this.isLoading = false
                
                this.alertDialog = {
                    show: true,
                    text: response.message,
                    color: "success"
                }

                this.$emit('handleprofileUpdate')

            } catch (error) {
                console.log(error);
                this.isLoading = false
            }
        },
        removeKey(keys) {
            for (const key of keys) {
                if(key in this.member) {
                    delete this.member[key];
                }
            }
        },
        handleCroppedImage(image) {
            console.log(image);
            
            this.croppedImagePreviewUrl = image
            this.userUpdatedImage = image
            this.showImageCropper = false
        }
    }        
}
</script>

<style lang="scss" scoped>

</style>